var React = require('react');

function CircleDotted (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"144","cy":"144","r":"143","stroke":"#C4C4C4","strokeWidth":"2","strokeLinecap":"square","strokeDasharray":"1 8"}));
}

CircleDotted.defaultProps = {"width":"288","height":"288","viewBox":"0 0 288 288","fill":"none"};

module.exports = CircleDotted;

CircleDotted.default = CircleDotted;
